import React, { useState } from "react";
import SideBar from "../components/SideBar";
import { Outlet } from "react-router-dom";

function TopRoute({ sideBarItems }) {
  const [searchText, setSearchText] = useState("");

  return (
    <>
      <SideBar items={sideBarItems} />
      <Outlet context={[searchText, setSearchText]} />
    </>
  );
}

export default TopRoute;
